<template>
    <div class="contenedor-noticias">

        <div class="container">


            <h3 v-if="noticiasByCategory.length == 0" class="title-intro no-line column-center"><strong>Noticias</strong> destacadas</h3>
            <h3 v-if="noticiasByCategory.length > 0" class="title-intro no-line column-center"><strong>Noticias</strong> que te pueden interesar</h3>


            <div class="noticias-list row-start">
                <h2 class="big-title">Noticias</h2>
                <noticia v-for="(data,key) in noticias.filter(e => e.priority == 1)" v-if="noticiasByCategory.length == 0" :key="key" :data="data"></noticia>
                <noticia v-for="(data,key) in noticiasByCategory" v-if="!!categoria" :key="key" :data="data"></noticia>
            </div>

    

        </div>


    </div>

</template>

<script>

    import noticia from '@/components/parts/noticia-el'


    import { mapGetters } from 'vuex';


    export default {
        name: 'noticias',
        props: ['categoria'],
        data() {
            return {
                data: ''
            }
        },
        computed: {
            ...mapGetters({
                noticias: 'getNoticias'
            }),
            noticiasByCategory(){
                let noticias;
                if(!!this.noticias){
                    noticias = this.noticias.filter(e => ((e.categories.some(c => (c.slug == this.categoria))) && (e.slug != this.$route.params.id )));
                }
                 return noticias;
            }
        },
        components: {
            'noticia': noticia
        },
    }
</script>

<style lang="scss" scoped>

    .title-intro{
        margin-bottom: 30px;
    }


    .noticias-list{
        position: relative;
    }

    .contenedor-noticias .big-title{
        top: -100px;
    }


    @media screen and (max-width:580px){
        .contenedor-noticias .big-title{
            top: auto;
        }

        .noticias-list{
            margin-top: -60px;
        }

        .title-intro{
            margin-bottom: 0;
        }
    }

    @media screen and (max-width:440px){
        
        .noticias-list{
            margin-top: -50px;
        }

    }

    @media screen and (max-width:375px){
        
        .noticias-list{
            margin-top: -20px;
        }

    }

</style>


// WEBPACK FOOTER //
// src/components/parts/noticias.vue